import React, { Component } from 'react'

import TweenMax, { TimelineMax, Expo, Power3 } from 'gsap'
import { router } from 'router'
import Scroller from 'src/utils/scroller'
import './styles.scss'
import components from 'src/utils/components'

export default class Header extends Component {
  constructor() {
    super()
    this.nativeCurrentY = 0
    this.scrollDirection = 0
    this.state = {
      open: false
    }
  }

  componentDidMount() {
    this.initTL()
  }

  initTL() {
    this.tlAnimateClose = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.video && this.video.playVideo()
        this.playerIsVisible = true
      }
    })

    this.tlAnimateClose
      .to(
        this.refs.rotateTop,
        0.6,
        {
          rotation: 135,
          ease: Expo.easeOut
        },
        0
      )
      .to(
        this.refs.rotateBtm,
        0.6,
        {
          rotation: 45,
          ease: Expo.easeOut
        },
        0.1
      )
  }

  onClick = () => {
    window.open(this.props.url)
  }

  onClickLogo = () => {
    Scroller.scrollTo(0, 0.5).then()
  }

  onClickMenu = () => {
    components.allComponents.homeMenuMobile.animateIn()
  }

  onMouseEnterClose = () => {
    this.tlAnimateClose.play()
  }

  onMouseLeaveClose = () => {
    this.tlAnimateClose.reverse()
  }

  onClickClose = () => {
    this.tlAnimateClose.reverse()
    const ctx = router.getContext()

    router.goto(`/${ctx.locale}`)
  }

  render() {
    return (
      <header ref="component" className="component header-world">
        <div onClick={this.onClickLogo} className="container-logo">
          <img ref="logo" src={`${process.env.PUBLIC_URL}/img/chaumet.png`} />
        </div>
        <span
          onMouseEnter={this.onMouseEnterClose}
          onMouseLeave={this.onMouseLeaveClose}
          onClick={this.onClickClose}
          ref="close"
          className="close">
          <span ref="rotateTop" className="line rotate-top" />
          <span ref="rotateBtm" className="line rotate-btm" />
        </span>
        <span className="border-btm" />
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/components/header/index.js